import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { NewButton, Icon, Text } from '../../../../../components';

const DataDictionaryToggleButton = styled(NewButton)`
  padding: 2px 4px;
  border-radius: 6px;
  /* &:hover {
    background-color: var(--wash-gray-hover);
  }
  &:active {
    background-color: var(--wash-gray-pressed);
  } */
`;

const DataDictionaryToggle = ({ onClick, label }) => (
  <DataDictionaryToggleButton onClick={onClick} secondary>
    <Icon name='book' displaySize={20} />
    <Text $bold $small>
      {label}
    </Text>
  </DataDictionaryToggleButton>
);
DataDictionaryToggle.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string
};

export { DataDictionaryToggle };
